



















































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import { Validator } from 'vee-validate';

import { ICustomer } from '@/interfaces/Customer';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';

@Component({
  components: {
    Input,
    Field,
  }
})
export default class InternForm extends Vue {
  @Prop()
  private value: any;

  @Prop({ required: true })
  private validator: Validator;

  private valuePhone = null;

  private maskDocument: string = '###.###.###-##';
  private maskPhone: string = '(##) #####-####';

  private change(input: string) {
    this.validator.validate(input, (this.$refs[input] as any).value);
  }

  private createValidations() {
    this.validator.attach({
      name: 'birthday',
      rules: 'required|isOverEighteenYearsOld',
    });

    this.validator.attach({
      name: 'phone',
      rules: 'required|min:15|phoneStartsWithNine',
    });
  }

  private filterPhoneIsActive(phones: any) {
    return phones.find((phone: any) => phone.is_active && phone.is_default);
  }

  @Watch('value', { immediate: true })
  onChangeValue(val: any) {
    if (val.phone_numbers && val.phone_numbers.length > 0) {
      const phoneActivated = this.filterPhoneIsActive(val.phone_numbers);
      this.valuePhone = phoneActivated && phoneActivated.phone.replace('+55', '');
    }
  }

  @Watch('valuePhone')
  onChangeValuePhone() {
    this.value.phone = this.valuePhone;
  }

  private mounted() {
    this.createValidations();
  }
}
